import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { Flux, FluxService } from 'src/app/service/flux-service';
import { ROUTES } from 'src/app/route/routes';
import { HomeService } from 'src/app/service/home.service';
import { LocalStorageService } from 'src/app/service/local-storage.service';
import { SessionStorageService } from 'src/app/service/session-storage.service';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-home-landing',
  templateUrl: './home-category.component.html',
  styleUrls: ['../home-landing/home-landing.component.scss'],
  standalone: false
})
export class HomeCategoryComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  flux: Flux = 'spa';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private lStorageService: LocalStorageService,
    private sStorageService: SessionStorageService,
    private homeService: HomeService,
    private spinner: SpinnerService,
    private fluxService: FluxService,
    public userService: UserService
  ) {}

  new_reservation_url = '';
  list_reservation_url = '';

  ngOnInit(): void {
    this.spinner.show();

    this.sStorageService.clearStorage();
    this.homeService.clearSubject();

    this.fluxService.initializeFromRoute(this.route);
    this.flux = this.fluxService.getCurrentFlux();
    this.list_reservation_url = this.flux + '/' + ROUTES.RESERVATION_LIST.path;
    this.new_reservation_url = this.flux + '/' + ROUTES.EVENT_LIST.path;

    this.spinner.hide();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToUrl(url: string): void {
    this.router.navigate([url]);
  }
}
